import type { Language } from '@/types/index';
import { eventsApi } from '@/lib/api';
import { useOptimizedQuery } from './useOptimizedQuery';

export function useEvents(language: Language, status?: 'upcoming' | 'past', category?: string) {
  return useOptimizedQuery({
    queryKey: ['events', language, status, category],
    queryFn: () => eventsApi.getAll(language, status, category),
    tier: 'content',
  });
}

export function useUpcomingEvents(language: Language, category?: string) {
  return useOptimizedQuery({
    queryKey: ['events', 'upcoming', language, category],
    queryFn: () => eventsApi.getUpcoming(language, category),
    tier: 'content',
  });
}

export function usePastEvents(language: Language, category?: string) {
  return useOptimizedQuery({
    queryKey: ['events', 'past', language, category],
    queryFn: () => eventsApi.getPast(language, category),
    tier: 'content',
  });
}

export function useFeaturedEvents(language: Language) {
  return useOptimizedQuery({
    queryKey: ['events', 'featured', language],
    queryFn: () => eventsApi.getFeatured(language),
    tier: 'content',
  });
}

export function useEventById(eventId: string, language: Language) {
  return useOptimizedQuery({
    queryKey: ['events', eventId, language],
    queryFn: () => eventsApi.getById(eventId, language),
    tier: 'content',
  });
}
